export const PaymentItemProps = {
    system: {
        type: Object,
        required: true,
    },
    disabled: Boolean,
};
